export function shouldSplitBmatThinkingSkillsPearsonItem(examName, moduleKey, question, bmatSitting) {
  if (!bmatSitting) return false;
  if (String(examName || '').toUpperCase() !== 'TARA') return false;
  if (moduleKey !== 'thinking_skills') return false;
  return String(question?.exhibit_text || '').trim().length > 0;
}
